// extracted by mini-css-extract-plugin
export var spotify = "spotify-embed-module--spotify--8fd29";